import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Table.scss';

const Table = ({ content, setup }) => (
	<div className={s.table} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, {}, setup) }} />
);

export default hot(module)(Table);
